import { uiInitialState as ui } from './initialStates/uiInitialState';

export const initialState = {
	ui
}
